import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LangProvider } from "./i18n";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import Sell from "./pages/Sell";
import Buy from "./pages/Buy";
import Rent from "./pages/Rent";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster
            position="top-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#141414",
                border: "1px solid rgba(212,175,55,0.3)",
                color: "#F5F5F0",
                borderRadius: 0,
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
          <Routes>
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/sell" element={<PublicLayout><Sell /></PublicLayout>} />
            <Route path="/buy" element={<PublicLayout><Buy /></PublicLayout>} />
            <Route path="/rent" element={<PublicLayout><Rent /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
